import { PostProcessorModule } from 'i18next'

const isCompanyMode = import.meta.env.VITE_COMPANY_MODE === 'true'

const patientToUserReplacements: Record<string, Array<{ from: RegExp; to: string }>> = {
  en: [
    { from: /\bPatients\b/g, to: 'Users' },
    { from: /\bPatient\b/g, to: 'User' },
    { from: /\bpatients\b/g, to: 'users' },
    { from: /\bpatient\b/g, to: 'user' },
    { from: /\bpatient's\b/g, to: 'user\'s' }
  ],
  it: [
    { from: /\bPazienti\b/g, to: 'Utenti' },
    { from: /\bPaziente\b/g, to: 'Utente' },
    { from: /\bpazienti\b/g, to: 'utenti' },
    { from: /\bpaziente\b/g, to: 'utente' },
    { from: /\bdel paziente\b/g, to: 'dell\'utente' },
    { from: /\bal paziente\b/g, to: 'all\'utente' },
    { from: /\bil paziente\b/g, to: 'l\'utente' }
  ],
  fr: [
    { from: /\bPatients\b/g, to: 'Utilisateurs' },
    { from: /\bPatient\b/g, to: 'Utilisateur' },
    { from: /\bpatients\b/g, to: 'utilisateurs' },
    { from: /\bpatient\b/g, to: 'utilisateur' },
    { from: /\bdu patient\b/g, to: 'de l\'utilisateur' },
    { from: /\bau patient\b/g, to: 'à l\'utilisateur' },
    { from: /\ble patient\b/g, to: 'l\'utilisateur' }
  ],
  de: [
    { from: /Patienten/g, to: 'Benutzer' },
    { from: /Patient/g, to: 'Benutzer' },
    { from: /patienten/g, to: 'benutzer' },
    { from: /patient/g, to: 'benutzer' }
  ],
  ar: [
    { from: /مريض/g, to: 'مستخدم' },
    { from: /مرضى/g, to: 'مستخدمون' },
    { from: /المريض/g, to: 'المستخدم' },
    { from: /المرضى/g, to: 'المستخدمون' }
  ]
}

export const companyModeProcessor: PostProcessorModule = {
  type: 'postProcessor',
  name: 'companyMode',
  process: function (value: string, key: string, options: any, translator: any) {
    if (!isCompanyMode) {
      return value
    }

    const language = translator.language || 'en'
    const replacements = patientToUserReplacements[language] || patientToUserReplacements.en

    let result = value

    replacements.forEach(({ from, to }) => {
      result = result.replace(from, to)
    })

    return result
  }
}
